export const urls = {
  linkedin: "https://www.linkedin.com/in/erdal-n-9754281b1/",
  github: "https://github.com/ErdalNayir",
  fastapiLib: "https://github.com/ErdalNayir",
  dotnetApi: "https://github.com/ErdalNayir/Asp.Net_Core_7.0_Web_Api",
  cqrsApi: "https://github.com/ErdalNayir/CQRS_Pattern_with_Identity_Docker",
  planlamaPro: "https://github.com/ErdalNayir/planlamapro-backend",
  cycamp: "https://6314e747063a091c48a88f3c--unique-kataifi-950851.netlify.app/",
  weather: "https://erdalnayirweatherapp.netlify.app/",
};
